import { useSelector } from "react-redux";
import { RootState } from "../store";

export const useUserRole = () => {
  return useSelector((state: RootState) => state.user.role);
};
